<form [formGroup]="form">
  <h1 mat-dialog-title [translate]="'parameters/quick_replies/details/graph/ai_connector/box_name_in_diagram'"></h1>

  <mat-dialog-content>
    <ng-container *ngIf="aiConnectorDescription; else spinner">
      <ng-container formArrayName="formArray">
        <div *ngFor="let control of formArray.controls; let i = index">
          <ng-container [formGroupName]="i">
            <ng-container [ngSwitch]="aiConnectorDescription.parameters[i].type">
              <!-- list -->
              <ng-container *ngSwitchCase="subbotParameterType.list">
                <ng-container [formArrayName]="aiConnectorDescription.parameters[i].name">
                  <div *ngFor="let control of getNestedFormArray(i).controls; let j = index">
                    <ng-container [formGroupName]="j">
                      <div class="input-type-list">
                        <mat-form-field [class.list-sibling]="j !== 0">
                          <mat-label *ngIf="j === 0">{{ aiConnectorDescription.parameters[i].description }}</mat-label>
                          <input matInput [formControlName]="aiConnectorDescription.parameters[i].name" type="text" />

                          <!-- error required -->
                          <mat-error
                            *ngIf="
                              getNestedFormArray(i).controls[j].get(aiConnectorDescription.parameters[i].name).errors
                                ?.required
                            "
                            translate="common/form_errors/required"></mat-error>

                          <!-- error pattern with regexp -->
                          <mat-error
                            *ngIf="
                              getNestedFormArray(i).controls[j].get(aiConnectorDescription.parameters[i].name).errors
                                ?.pattern
                            "
                            ><span translate="common/form_errors/invalid_pattern"></span> :
                            {{ aiConnectorDescription.parameters[i].specification.regexp }}</mat-error
                          >
                        </mat-form-field>

                        <button
                          *ngIf="j === 0; else remove"
                          type="button"
                          mat-icon-button
                          (click)="addFieldInListType(i, aiConnectorDescription.parameters[i].name)">
                          <mat-icon color="primary">add_circle_outline</mat-icon>
                        </button>
                        <ng-template #remove>
                          <button type="button" mat-icon-button (click)="removeFieldInListType(i, j)">
                            <mat-icon color="warn">remove_circle_outline</mat-icon>
                          </button>
                        </ng-template>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="subbotParameterType.select">
                <app-select
                  [control]="getNestedFormArray(i)"
                  [items]="appSelectSimpleChoices[aiConnectorDescription.parameters[i].name]"
                  [label]="aiConnectorDescription.parameters[i].name">
                  ></app-select
                >
              </ng-container>

              <!-- default -->
              <mat-form-field *ngSwitchDefault>
                <mat-label>{{ aiConnectorDescription.parameters[i].description }}</mat-label>
                <input matInput [formControlName]="aiConnectorDescription.parameters[i].name" type="text" />

                <!-- error required -->
                <mat-error
                  *ngIf="formArray.controls[i].get(aiConnectorDescription.parameters[i].name).errors?.required"
                  translate="common/form_errors/required"></mat-error>

                <!-- error not a number -->
                <mat-error
                  *ngIf="
                    aiConnectorDescription.parameters[i].type === subbotParameterType.integer &&
                    formArray.controls[i].get(aiConnectorDescription.parameters[i].name).errors?.pattern
                  "
                  translate="common/form_errors/numerical"></mat-error>

                <!-- error pattern with regexp -->
                <mat-error
                  *ngIf="
                    aiConnectorDescription.parameters[i].type !== subbotParameterType.integer &&
                    formArray.controls[i].get(aiConnectorDescription.parameters[i].name).errors?.pattern
                  "
                  ><span translate="common/form_errors/invalid_pattern"></span> :
                  {{ aiConnectorDescription.parameters[i].specification.regexp }}</mat-error
                ></mat-form-field
              >
            </ng-container>
          </ng-container>
        </div>
      </ng-container>

      <div class="inputs-outputs">
        <!-- inputs variables -->
        <div>
          <div class="alc-label-text" translate="parameters/quick_replies/details/graph/subbot_input_variables"></div>
          <div *ngFor="let input of aiConnectorDescription.input_variables" [matTooltip]="input.description">
            {{ input.name }}
          </div>
        </div>
        <!-- outputs variables -->
        <div>
          <div class="alc-label-text" translate="parameters/quick_replies/details/graph/subbot_output_variables"></div>
          <div *ngFor="let output of aiConnectorDescription.output_variables" [matTooltip]="output.description">
            {{ output.name }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #spinner>
      <div class="alc-spinner-wrapper-in-flow">
        <mat-spinner diameter="50" color="accent"></mat-spinner>
      </div>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button type="submit" color="primary" [disabled]="form.invalid" [mat-dialog-close]="elementData">
      <span translate="save"></span>
    </button>
    <button mat-raised-button type="button" mat-dialog-close><span translate="cancel"></span></button>
  </mat-dialog-actions>
</form>
